import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const HideIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Hide",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.8 14.92c-1.42-2.42-2.91-3.95-4.99-5.3l-.05-.03 2.92-3.03c.3-.31.47-.73.47-1.2s-.18-.89-.48-1.21c-.32-.31-.75-.52-1.23-.52s-.93.2-1.24.52l-3.82 3.82c-1.58-.57-3.41-.89-5.31-.89h-.3c-5.82 0-10.88 3.18-13.57 7.89 0 0-.2.35-.2.87 0 .42.16.8.16.8 1.25 2.23 2.96 4.06 5.01 5.42l.05.04-2.91 3.02c-.46.48-.84.95-.84 1.5 0 1.08.84 1.76 1.75 1.76.59 0 1.08-.42 1.5-.83l3.89-3.89c1.6.6 3.46.94 5.38.96h.23c5.82 0 10.89-3.18 13.57-7.9 0 0 .22-.44.22-.85s-.13-.81-.2-.93ZM9.77 19.57c-1.62-.95-3.96-3.67-3.99-3.69s0-.06 0-.06c2.23-3.2 5.87-5.25 10.01-5.25h.19c1.55 0 2.56.24 2.56.24l-1.45 1.45c-.34-.1-.71-.17-1.08-.17a3.66 3.66 0 0 0-3.66 3.65c0 .38.06.74.17 1.09l-2.74 2.74Zm16.43-3.72c-2.23 3.19-5.99 5.23-10.01 5.23-1.66 0-2.74-.23-2.74-.23l1.59-1.59c.31.09.62.13.95.13a3.66 3.66 0 0 0 3.65-3.66c0-.33-.04-.65-.13-.95l2.69-2.69c1.62.95 3.96 3.67 3.99 3.7.02.03 0 .06 0 .06Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.43 29.29c-.29 0-.58-.11-.81-.33L2.48 3.81c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l25.14 25.14a1.14 1.14 0 0 1-.81 1.95ZM27.29 20.68c-.32 0-.64-.13-.87-.4-.41-.48-.36-1.2.12-1.61 1.06-.91 2-1.96 2.8-3.1a16.34 16.34 0 0 0-13.49-7.06c-.36 0-.71.01-1.07.03-.63.03-1.17-.44-1.22-1.07S14 6.3 14.63 6.25c.4-.03.81-.04 1.22-.04 6.45 0 12.36 3.27 15.82 8.74.24.37.24.85 0 1.22-1 1.58-2.23 3-3.65 4.23-.22.19-.48.28-.74.28ZM15.86 24.92c-6.45 0-12.36-3.27-15.82-8.74-.24-.37-.24-.85 0-1.22 1-1.58 2.23-3 3.65-4.22a1.14 1.14 0 1 1 1.49 1.73c-1.06.91-2 1.96-2.8 3.1 3.08 4.44 8.07 7.06 13.49 7.06.72 0 1.44-.05 2.14-.14.62-.09 1.2.36 1.28.98s-.36 1.2-.98 1.28c-.8.1-1.62.16-2.44.16Z"
      })
    })
  }));
};
HideIcon.displayName = 'HideIcon';